import AffiliatesHeroImg from "../../../../assets/affiliates/heroImg.png";
import Arrow from "../../../../assets/icons/arrow.svg";
import { useTranslation } from "react-i18next";
import { useLanguageTheme } from "../../../../hooks/useLanguageTheme";
import { Theme, useMediaQuery } from "@mui/material";
import YellowLines from "../../../../assets/affiliates/yellowLines.svg";
import { useAuth } from "../../../../hooks/useAuth";
import { useUserProfile } from "../../../../hooks/useUserProfile";
import { useAffiliateNavigation } from "../../hooks/useAffiliateNavigation";

export const AffiliatesHeroImgSection = () => {
  const { t, i18n } = useTranslation(["affiliates"]);
  const isRTL = i18n.dir() === "rtl";

  const isAuthenticated = useAuth();
  const { handleAffiliateNavigation } = useAffiliateNavigation();
  const { profile }: { profile: any } = useUserProfile();

  const langTheme = useLanguageTheme();
  const is1500 = useMediaQuery("(max-width: 1500px)");
  const is1200 = useMediaQuery("(max-width: 1200px)");
  const downMd = useMediaQuery((theme: Theme) => theme.breakpoints.down("md"));

  return (
    <div
      className="affiliates-hero-img-wrapper"
      style={{
        fontFamily: langTheme.mainFont(),
        direction: i18n.dir(),
      }}
    >
      <div className="affiliates-hero-img-info-block">
        <div
          style={{
            paddingLeft: is1200 ? "20px" : isRTL ? 0 : "35px",
            paddingRight: is1200 ? "20px" : isRTL ? "35px" : 0,
          }}
        >
          <div className="sentom-RE-affiliate-program">
            {t("sentom_RE_affiliate_program")}
          </div>
          <div
            className="affiliates-hero-img-title"
            style={{
              fontFamily: isRTL ? "Noto Sans Hebrew" : "Frank Ruhl Libre",
            }}
          >
            {t("hero_img_title")}
          </div>
          <div className="affiliates-hero-img-desc">
            {t("hero_img_title_desc")}
          </div>

          <div
            className="become-affiliate-btn-wrapper"
            onClick={() => handleAffiliateNavigation(isAuthenticated, profile)}
          >
            <div>{t("become_an_affiliate")}</div>
            <img
              src={Arrow}
              alt="arrow"
              style={{
                transform: isRTL ? "scaleX(-1)" : " scaleX(1)",
              }}
            />
          </div>
        </div>
        <img
          className="yellow-lines"
          src={YellowLines}
          style={{
            top: is1500 ? "auto" : "170px",
            display: downMd ? "none" : "block",
            transform: isRTL ? "scaleX(-1)" : "scaleX(1)",
          }}
          alt="yellow-lines"
        />
      </div>

      <div
        className="affiliates-hero-img-img-block"
        style={{
          transform: isRTL ? "scaleX(-1)" : "scaleX(1)",
          background: `url(${AffiliatesHeroImg}) center center / cover  no-repeat`,
        }}
      ></div>
    </div>
  );
};
